export const coreRoutesNames = {
    ROOT: '',
    MAIN: 'app',
    AUTH: 'auth',
    ADMIN: 'admin'
};
